import { useState } from 'react';
import { downloadCsv, useConsumptionTax } from '../hooks/useReports';
import PrintButton from '../components/PrintButton';

export default function ConsumptionTaxPage() {
  const currentYear = new Date().getFullYear();
  const [fiscalYear, setFiscalYear] = useState(currentYear);
  const [applied, setApplied] = useState<number | undefined>(currentYear);

  const { data, isLoading, error } = useConsumptionTax(applied);

  return (
    <div>
      <div className="page-header">
        <h2>消費税集計表（一般課税）</h2>
      </div>
      {error && <div className="error-banner">{(error as Error).message}</div>}

      <div className="card">
        <div className="toolbar">
          <label>
            事業年度{' '}
            <input
              type="number"
              value={fiscalYear}
              onChange={(e) => setFiscalYear(Number(e.target.value))}
              style={{ width: 100 }}
            />
          </label>
          <button className="primary" onClick={() => setApplied(fiscalYear)}>
            表示
          </button>
          <button
            onClick={() => applied && downloadCsv('/api/reports/consumption-tax', { fiscalYear: applied })}
            disabled={!applied}
          >
            CSV出力
          </button>
          <PrintButton />
        </div>
      </div>

      {isLoading && <div>読み込み中...</div>}

      {data && (
        <>
          <table>
            <thead>
              <tr>
                <th>項目</th>
                <th className="numeric" style={{ width: 160 }}>金額（円）</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2} style={{ background: '#eef0f3', fontWeight: 600 }}>
                  課税売上
                </td>
              </tr>
              <tr>
                <td>課税売上額（10%・税抜）</td>
                <td className="numeric">{data.sales.net10.toLocaleString()}</td>
              </tr>
              <tr>
                <td>課税売上額（8%軽減・税抜）</td>
                <td className="numeric">{data.sales.net8.toLocaleString()}</td>
              </tr>
              <tr>
                <td>仮受消費税（10%）</td>
                <td className="numeric">{data.sales.outputTax10.toLocaleString()}</td>
              </tr>
              <tr>
                <td>仮受消費税（8%軽減）</td>
                <td className="numeric">{data.sales.outputTax8.toLocaleString()}</td>
              </tr>
              <tr>
                <th>仮受消費税合計</th>
                <th className="numeric">{data.sales.outputTaxTotal.toLocaleString()}</th>
              </tr>

              <tr>
                <td colSpan={2} style={{ background: '#eef0f3', fontWeight: 600 }}>
                  課税仕入（インボイスあり・控除対象）
                </td>
              </tr>
              <tr>
                <td>課税仕入額（10%・税抜）</td>
                <td className="numeric">{data.purchases.net10WithInvoice.toLocaleString()}</td>
              </tr>
              <tr>
                <td>課税仕入額（8%軽減・税抜）</td>
                <td className="numeric">{data.purchases.net8WithInvoice.toLocaleString()}</td>
              </tr>
              <tr>
                <td>仕入税額控除（10%）</td>
                <td className="numeric">{data.purchases.inputTax10.toLocaleString()}</td>
              </tr>
              <tr>
                <td>仕入税額控除（8%軽減）</td>
                <td className="numeric">{data.purchases.inputTax8.toLocaleString()}</td>
              </tr>
              <tr>
                <th>仕入税額控除合計</th>
                <th className="numeric">{data.purchases.inputTaxTotal.toLocaleString()}</th>
              </tr>

              <tr>
                <td colSpan={2} style={{ background: '#fbeae6', fontWeight: 600 }}>
                  課税仕入（インボイスなし・控除対象外）
                </td>
              </tr>
              <tr>
                <td>課税仕入額（10%・税抜）</td>
                <td className="numeric">{data.purchases.net10WithoutInvoice.toLocaleString()}</td>
              </tr>
              <tr>
                <td>課税仕入額（8%軽減・税抜）</td>
                <td className="numeric">{data.purchases.net8WithoutInvoice.toLocaleString()}</td>
              </tr>

              <tr>
                <th style={{ background: '#e6f4ec' }}>差引納付税額</th>
                <th
                  className="numeric"
                  style={{
                    fontSize: 16,
                    background: '#e6f4ec',
                    color: data.taxPayable >= 0 ? 'var(--color-success)' : 'var(--color-danger)',
                  }}
                >
                  {data.taxPayable.toLocaleString()}
                </th>
              </tr>
            </tbody>
          </table>
          <p className="text-muted" style={{ fontSize: 12, marginTop: 12 }}>
            ※ {data.purchases.uncreditableNote}
          </p>
        </>
      )}
    </div>
  );
}
